import * as React from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ColorPicker from './ColorPicker';
import {Action} from '../../../system/buttons';
import FontPicker from './FontPicker';
import Ranges from '../../../system/ranges';
import {BpmAnimationSelect} from '../../../system/BpmAnimationSelect/BpmAnimationSelect';

export class TextWidgetEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.configuration,
      visibilityDraft: true,
      rangeColorDraft: '#ff0000',
      showRangePicker: false,
    };
  }

  between(a, from, to) {
    return a >= from && a <= to;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState !== this.state) {
      this.props.onUpdate({
        alignment: this.state.alignment,
        font: this.state.font,
        backgroundColor: this.state.backgroundColor,
        ranges: this.state.ranges,
      });
    }
  }

  render() {
    return (
      <>
        <Ranges
          ranges={this.state.ranges}
          onRangesChange={(ranges) => this.setState({ranges})}
          defaultRange={{
            from: 60,
            to: 90,
            animation: 'shake-no',
            text: 'Any text',
            color: '#ff5373',
          }}
          header={
            <Col md={7}>
              <Form inline>
                <Col>Text</Col>
                <Col>Animation</Col>
                <Col>Color</Col>
              </Form>
            </Col>
          }
          rangeConfiguration={(range, onRangeChange) => (
            <Col md={7} key={range.from}>
              <Form inline>
                <Col>
                  <Form.Control
                    value={range.text}
                    onChange={(e) => {
                      onRangeChange({...range, text: e.target.value});
                    }}
                  />
                </Col>
                <Col>
                  <BpmAnimationSelect
                    onChange={(e) => onRangeChange({...range, animation: e})}
                    value={range.animation}
                  />
                </Col>
                <Col>
                  <ColorPicker
                    color={range.color}
                    onChangeComplete={(color) =>
                      onRangeChange({
                        ...range,
                        color,
                      })
                    }
                  />
                </Col>
              </Form>
            </Col>
          )}
        />
        <Row>&nbsp;</Row>

        <FontPicker
          font={this.state.font}
          onChange={(font) => this.setState({font})}
        />

        <Form.Group as={Row}>
          <Form.Label column sm="2">
            Alignment
          </Form.Label>
          <Col sm="3">
            <Form.Control
              as="select"
              value={this.state.alignment}
              onChange={(e) => this.setState({alignment: e.target.value})}
            >
              <option key={1}>left</option>
              <option key={2}>center</option>
              <option key={3}>right</option>
            </Form.Control>
          </Col>
        </Form.Group>

        <Action
          onClick={() =>
            this.props.onSave({
              alignment: this.state.alignment,
              font: this.state.font,
              backgroundColor: this.state.backgroundColor,
              ranges: this.state.ranges,
            })
          }
        >
          Save settings
        </Action>
      </>
    );
  }
}
